export default __webpack_public_path__ + "static/media/image2pro1.47e8841d.jpeg";